import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=1a08eb2f&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=ts&"
export * from "./TaskList.vue?vue&type=script&lang=ts&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=1a08eb2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08eb2f",
  null
  
)

export default component.exports